import React, { useState } from "react"
import { connect } from "react-redux"
import { Box } from "@infotech/uikit-grid"
import { readStatusModel } from "src/engine/modules/EventType/StatusModel/actions/creators"
import { useReadModelList } from "src/engine/modules/EventType/StatusModel/hook"
import { selectStatusesList } from "src/engine/modules/EventType/StatusModel/selectors"
import { useNow } from "src/hooks"
import { MiniButton, FlatIconButton } from "@infotech/uikit-button"
import tooltip from "@infotech/uikit-tooltip"
import {
  AddIcon,
  TrashIcon,
  EditIcon,
  EyesOnIcon,
  OkIcon,
} from "@infotech/uikit-icons"
import { removeEventStatus } from "./AddStatusForm/helper"
import AddStatusForm from "./AddStatusForm"
import CreateStatus from "./CreateStatus"
import styles from "./styles.css"

const TooltipSpan = tooltip.span()

const StatusListItem = ({
  name,
  color,
  id,
  initial,
  toggleForm,
  refreshList,
  statusModelPermission,
}) => {
  return (
    <Box
      loose
      flex
      row
      className={styles.StatusListItemWrapper}
      pt="6px"
      pb="4px"
      pl="1md"
      pr="2md"
    >
      <Box loose flex row>
        <Box
          loose
          className={styles.StatusCircle}
          style={{ backgroundColor: color }}
          pl="1md"
          mt="5px"
        />
        <Box loose className={styles.StatusName} style={{ color }} pl="1md">
          {name}
        </Box>
        {initial && (
          <Box loose pl="1md">
            <OkIcon color="#18981d" size="small" />
          </Box>
        )}
      </Box>
      <Box loose flex row pt="2px" pl="2md" className={styles.Icons}>
        <Box loose>
          <TooltipSpan
            tooltip={statusModelPermission ? `Редактировать` : `Просмотр`}
            tooltipConfig={{
              placement: `top`,
            }}
          >
            <Box loose>
              <FlatIconButton
                clean
                icon={statusModelPermission ? EditIcon : EyesOnIcon}
                iconSize="small"
                onClick={() => {
                  toggleForm({ show: true, id })
                }}
              />
            </Box>
          </TooltipSpan>
        </Box>
        {statusModelPermission && (
          <Box loose pl="1md">
            <TooltipSpan
              tooltip="Удалить"
              tooltipConfig={{
                placement: `top`,
              }}
            >
              <Box loose>
                <FlatIconButton
                  clean
                  icon={TrashIcon}
                  iconSize="small"
                  onClick={() => {
                    removeEventStatus({ id, refreshList, name })
                  }}
                />
              </Box>
            </TooltipSpan>
          </Box>
        )}
      </Box>
    </Box>
  )
}

const StatusesList = ({
  id,
  readStatusModel,
  statusesList,
  statusModelPermission,
  resourceTypeList,
}) => {
  const [refreshTimestamp, refreshList] = useNow()
  const [formData, toggleForm] = useState({ show: false, id: null })
  const [showCreateStatus, triggerCreateStatus] = useState(false)

  useReadModelList({ id, readList: readStatusModel, refresh: refreshTimestamp })

  return (
    <Box loose pt="3md" flex column>
      <Box loose flex row>
        <Box loose className={styles.StatusHeader} pl="2md">
          Статусы
        </Box>
        <Box loose pl="2md" pt="2px">
          <MiniButton
            disabled={!statusModelPermission}
            icon={AddIcon}
            onClick={() => toggleForm({ show: true, id: null })}
          />
        </Box>
      </Box>
      <Box loose pt="2md">
        {!statusesList.length ? (
          <Box loose className={styles.StatusListEmpty} pl="2md">
            Добавьте статус
          </Box>
        ) : (
          statusesList.map(item => (
            <Box loose pl="1md">
              <StatusListItem
                {...item}
                refreshList={refreshList}
                toggleForm={toggleForm}
                statusModelPermission={statusModelPermission}
              />
            </Box>
          ))
        )}
      </Box>
      {formData.show && (
        <AddStatusForm
          eventTypeId={id}
          resourceTypeList={resourceTypeList}
          refreshList={refreshList}
          statusModelPermission={statusModelPermission}
          formData={formData}
          toggleForm={toggleForm}
          statusesList={statusesList.map(item => item.code)}
          closeModal={() => toggleForm({ show: false, id: null })}
          triggerCreateStatus={triggerCreateStatus}
        />
      )}
      {showCreateStatus && (
        <CreateStatus
          toggleForm={toggleForm}
          triggerCreateStatus={triggerCreateStatus}
          showCreateStatus={showCreateStatus}
        />
      )}
    </Box>
  )
}

export default connect(
  state => ({
    statusesList: selectStatusesList(state),
  }),
  {
    readStatusModel,
  },
)(StatusesList)
